import { store } from '../index';

export function isAuthor(authorId) {
	let currentUserId = store?.getState()?.user?._id;
	if (currentUserId === authorId) {
		return true;
	}
	return false;
}
